/* eslint-disable react/no-array-index-key */
import { Card } from "@repo/ui";
import { MdKeyboardArrowRight } from "react-icons/md";

const statusProgress = [
  { text: "New", value: "Open" },
  { text: "Assigned", value: "Assigned" },
  { text: "In Progress", value: "In Progress" },
  { text: "On Hold", value: "On Hold" },
  { text: "Resolved", value: "Resolved" },
  { text: "Closed", value: "Closed" },
];
export function StatusBar({ ticketStatus }) {
  return (
    <div className="flex flex-row w-full justify-between items-center my-2">
      <Card
        className="form-card shadow-none rounded-lg mx-0 "
        style={{ padding: "12px 2rem" }}
      >
        <div className="flex flex-row w-full justify-between items-center my-2">
          {statusProgress.map((elm, index) => (
            <>
              {index === 0 ? null : <MdKeyboardArrowRight fontSize="20" />}
              <div className="flex flex-col items-center justify-center gap-1">
                <div
                  key={index}
                  className={
                    elm.value === ticketStatus
                      ? "w-4 h-4 rounded-[50%] border border-solid border-1 border-secondary bg-secondary"
                      : "w-4 h-4 rounded-[50%]  border border-solid border-1  border-secondary bg-white"
                  }
                />
                <p>{elm.text}</p>
              </div>
            </>
          ))}
        </div>
      </Card>
    </div>
  );
}
